// import { theme } from './lib/theme';
import {
  createTheme,
  MantineProvider,
  // useMantineColorScheme,
} from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { type PropsWithChildren, useMemo } from 'react';

// const theme = createTheme({
//   components: {
//     Drawer: {
//       defaultProps: {
//         overlayProps: {
//           blur: 1.5,
//           color: '#012',
//           opacity: 0.4,
//         },
//       },
//     },
//     Modal: {
//       defaultProps: {
//         overlayProps: {
//           blur: 1.5,
//           color: '#012',
//           opacity: 0.4,
//         },
//       },
//       // styles: () => ({
//       //   modal: {
//       //     boxShadow: '0 0 6px rgba(0, 0, 0, .3)',
//       //   },
//       // }),
//     },
//     Notifications: {
//       classNames: css,
//     },
//   },
// });

export const Mantine = ({
  children,
  forceColorScheme,
}: PropsWithChildren & { readonly forceColorScheme?: 'dark' | 'light' }) => {
  // const { colorScheme } = useMantineColorScheme();
  const theme = useMemo(
    () =>
      createTheme({
        components: {
          // Overlay: Overlay.extend({
          //   defaultProps: {
          //     className: 'backdrop-blur-lg',
          //     // blur: 2,
          //     // color: '#234',
          //     // opacity: 1,
          //   },
          // }),
          Modal: {
            classNames: {
              title: 'font-medium',
            },
          },
          // Drawer: {},
          // Modal: {},
          Notifications: {
            classNames: { notification: 'clew-notification' },
          },
          Overlay: { classNames: { root: 'backdrop-blur-[3px]' } },
        },
      }),
    [],
  );

  return (
    <MantineProvider
      colorSchemeManager={
        forceColorScheme
          ? {
              clear: () => undefined,
              get: () => forceColorScheme,
              set: () => undefined,
              subscribe: () => undefined,
              unsubscribe: () => undefined,
            }
          : undefined
      }
      theme={theme}
    >
      <Notifications position="bottom-center" />
      <ModalsProvider>{children}</ModalsProvider>
    </MantineProvider>
  );
};
